function FeedComponentContainer(props){
    const className = "feedComponentContainer " + (props.className || "");
    return <div className={className}>
        {props.title && <div className="title">{props.title}</div>}
        <div className="content">{props.children}</div>
    </div>
}

export default FeedComponentContainer;